export enum CustumerEnum {
    SMARTMLS = 'smartmls',
    SABOR = 'sabor'
}